var _rect, _polyline, _polyline2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#0000CD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    points: "64 88 16 128 64 168"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#0000CD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    points: "192 88 240 128 192 168"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    x2: 96,
    y1: 40,
    y2: 216,
    fill: "none",
    stroke: "#0000CD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.ea3d52e7142152500343513dd1c7acaa.svg";
export { ForwardRef as ReactComponent };